import React from 'react';

import styled from 'styled-components';

import Select from 'components/lib/Select';

type StatusOption = {
  label: string;
  value: number;
};

type Props = {
  value: number;
  options: StatusOption[];
  statusColorMap: Record<number, string>;
  onChange: (status: number) => void;
  dataTestId?: string;
};

const StyledSelect = styled(Select)<{ statuscolor: string }>`
  &&&.ant-select {
    width: 152px;
    height: 34px;

    .ant-select-selection-item {
      font-size: 14px;
    }

    .ant-select-selector {
      border: none;
      padding: 0 6px 0 7px;
      border-radius: 4px;
      background: ${({ statuscolor }) => statuscolor};
    }
  }
`;

const ActionPlanStatusSelector = ({ value, options, statusColorMap, onChange, dataTestId }: Props) => {
  return (
    <StyledSelect
      value={value}
      options={options}
      statuscolor={statusColorMap[value] || 'var(--text-primary)'}
      onChange={(status) => onChange(Number(status))}
      onClick={(event) => event.stopPropagation()}
      dataTestId={dataTestId}
    />
  );
};

export default ActionPlanStatusSelector;
